import React, { useEffect, useState } from "react";
import RelatedCourse from "./Sliders/RelatedCourse";
// import { relatedCourse } from "../../../Mock/Home";
import { recorded_course } from "../../../Mock/Learn";
import axios from "axios";

const CoursesMainContainer = () => {
  let [state, setState] = useState([]);

  useEffect(() => {
    let fetchCards = async () => {
      let response = await axios.get(
        "https://vercel-deployment-w4ja.onrender.com/api/get_all_cards"
      );
      setState(response.data);
    };
    fetchCards();
  }, []);

  return (
    <div className=" max-w-7xl m-auto mt-12 max-sm:px-5" id="courses">
      <h1 className="text-[#2C3E50] text-2xl font-semibold mb-10 max-sm:text-lg">
        Unlock Your Potential With Our Courses!!
      </h1>
      <div className="relative">
        <div className="max-w-6xl m-auto">
          <RelatedCourse data={recorded_course} />
        </div>
      </div>
    </div>
  );
};

export default CoursesMainContainer;
